module.exports = __webpack_public_path__ + "static/media/version.da458926.svg";